(function() {
    "use strict";
    // TODO: Remove no-js from the body
    var initiatives = {
        "init": function() {
            //this.start();
            this.getParams();
            this.baseUrl = baseUrl == "" ? new URL("https://1234-cs-8bcb5d64-eb88-4419-bb77-9726a6cc5207.cs-asia-southeast1-yelo.cloudshell.dev/initiatives.htm") : baseUrl;
            this.basePath = basePath == "" ? "/initiatives.html" : basePath;
            this.currentPage = this.urlParams.page == undefined ? 1 : this.urlParams.page;
            this.getData();
            this.newUrlState = "";
            var that = this;
            document.querySelector('.topical__pagination-per-page select[name="per-page"]').addEventListener("change", function(e) {
                that.changePerPage(e);
            });
            this.defaultAllTopic = true;
            this.topics.every(function(v, k) {
                if (v.key == that.urlParams.topic || Array.isArray(that.urlParams.topic) && that.urlParams.topic.includes(v.key)) {
                    that.defaultAllTopic = false;
                    that.newUrlState += that.newUrlState == "" ? "?topic=" + v.key : "&topic=" + v.key;
                }
                return true;
            });
            document.querySelector("#topic-all").checked = this.defaultAllTopic;
            this.searchReset();
            this.searchSubmit();
        },
        "searchReset": function() {
            document.querySelector("input[name='search-reset']").addEventListener("click", function(e) {
                document.querySelector("input[name='search-keywords']").value = "";
                document.querySelector("#topic-all").checked = false;
                document.querySelector("#topic-all").click();
                e.preventDefault();
                return false;
            });
        },
        "searchSubmit": function() {
            var that = this;
            document.querySelector("input[name='search-submit']").addEventListener("click", function(e) {
                that.keywords = document.querySelector("input[name='search-keywords']").value;
                if (that.keywords.trim() != "") {
                    that.buildQueryString("search", encodeURIComponent(that.keywords));
                    that.buildResults();
                    history.replaceState(null, "", that.newUrlState);
                }
                e.preventDefault();
                return false;
            });
        },
        "matchKeywords": function(keywords, content) {
            if (keywords.length == 0) return true;
            else {
                let found = false;
                keywords.every(function(v, k) {
                    if (content.name.toLowerCase().includes(v.toLowerCase())) {
                        found = true;
                        return false;
                    } else if (content.tile_desc.toLowerCase().includes(v.toLowerCase())) {
                        found = true;
                        return false;
                    }
                });
                return found;
            }
        },
        "start": function() {
            Array.from(document.getElementsByClassName("accordion__all-toggler")).forEach(function(element) {
                element.addEventListener("click", function(ev) {
                    var isCollapsed = ev.currentTarget.getAttribute("data-toggle-expand") == "yes";
                    if (isCollapsed) {
                        ev.currentTarget.textContent = ev.currentTarget.getAttribute("data-text-open");
                        ev.currentTarget.setAttribute("data-toggle-expand", "no");
                    } else {
                        ev.currentTarget.setAttribute("data-toggle-expand", "yes");
                        ev.currentTarget.textContent = ev.currentTarget.getAttribute("data-text-close");
                    }
                    ev.currentTarget.closest("div").nextElementSibling.querySelectorAll("details").forEach(function(el) {
                        if (isCollapsed && el.hasAttribute("open") || !isCollapsed && !el.hasAttribute("open")) el.toggleAttribute("open");
                    });
                    ev.preventDefault();
                    return false;
                }, false);
            });
        },
        "getParams": function() {
            this.urlParams = {};
            var that = this;
            (window.onpopstate = function() {
                let match, pl = /\+/g, search = /([^&=]+)=?([^&]*)/g, decode = function(s) {
                    return decodeURIComponent(s.replace(pl, " "));
                }, query = window.location.search.substring(1);
                while(match = search.exec(query))if (decode(match[1]) in that.urlParams) {
                    if (!Array.isArray(that.urlParams[decode(match[1])])) that.urlParams[decode(match[1])] = [
                        that.urlParams[decode(match[1])]
                    ];
                    that.urlParams[decode(match[1])].push(decode(match[2]));
                } else that.urlParams[decode(match[1])] = decode(match[2]);
            })();
        },
        "buildTopicQueryString": function() {
            this.topicQueryString = "";
            var that = this;
            if (Array.isArray(this.urlParams.topic)) this.urlParams.topic.forEach(function(v) {
                that.topicQueryString += that.topicQueryString == "" ? "?topic=" + v : "&topic=" + v;
            });
            else if (this.urlParams.topic != undefined) this.topicQueryString += "?topic=" + this.urlParams.topic;
        },
        "buildQueryString": function(whatChange, newValue) {
            var that = this;
            var queryString = "";
            that.getParams();
            if (Object.keys(that.urlParams).length == 0) that.newUrlState += "?" + whatChange + "=" + newValue;
            else {
                if (Array.isArray(that.urlParams.topic)) that.urlParams.topic.forEach(function(v, k) {
                    queryString += queryString == "" ? "?topic=" + v : "&topic=" + v;
                });
                else if (that.urlParams.topic != undefined) queryString += queryString == "" ? "?topic" + that.urlParams.topic : "&topic=" + that.urlParams.topic;
                if (that.urlParams.page != undefined && whatChange != "page") queryString += queryString == "" ? "?page" + that.urlParams.page : "&page=" + that.urlParams.page;
                if (that.urlParams.search != undefined && whatChange != "search") queryString += queryString == "" ? "?search" + that.urlParams.search : "&search=" + that.urlParams.search;
                queryString += queryString == "" ? "?" + whatChange + "=" + newValue : "&" + whatChange + "=" + newValue;
                this.newUrlState = this.basePath + queryString;
            }
        },
        "getData": function() {
            this.results = initiativeData;
            this.buildFilter();
            this.getPerPage();
            this.buildResults();
        },
        "buildPagination": function() {
            var that = this;
            // Showing
            let total = this.filteredResults.length;
            // Start from 1?
            let startFrom = ((this.currentPage == undefined ? 1 : this.currentPage) - 1) * this.perPage + 1;
            //let totalInPage = total <= this.perPage ? total : this.perPage;
            let toPage = parseInt(startFrom) + this.perPage - 1 < total ? parseInt(startFrom) + this.perPage - 1 : total;
            if (total == 0) document.querySelector(".topical__pagination-page-showing").innerText = "No results found";
            else document.querySelector(".topical__pagination-page-showing").innerText = "Showing " + startFrom + "-" + toPage + " of " + total;
            this.totalOfPages = Math.ceil(total / this.perPage);
            var elParent = document.querySelector(".topical__pagination ul");
            elParent.querySelectorAll(".page-number").forEach((e)=>e.remove());
            if (that.totalOfPages > 1) {
                elParent.style.display = "flex";
                let elLast = elParent.querySelector(".page-next");
                for(var v = 1; v <= that.totalOfPages; v++){
                    let li = document.createElement("li");
                    li.classList.add("page-number");
                    let a = document.createElement("a");
                    a.setAttribute("href", "#" + v);
                    a.setAttribute("onclick", "return false;");
                    //a.setAttribute('href', '&page=' + v);
                    a.setAttribute("data-page-num", v);
                    if (v == that.currentPage) a.classList.add("page-current");
                    a.innerText = v;
                    a.addEventListener("click", function(e) {
                        (e)=>e.preventDefault();
                        that.goToPage(e);
                        return false;
                    });
                    li.appendChild(a);
                    elParent.insertBefore(li, elLast);
                }
            } else elParent.style.display = "none";
        },
        "getPerPage": function() {
            this.perPage = parseInt(document.querySelector("select[name='per-page']").value);
        //this.currentPage = 1;
        },
        "goToPage": function(e) {
            this.currentPage = e.target.getAttribute("data-page-num");
            // Ignore invalid page num
            if (this.currentPage <= this.totalOfPages) {
                this.resultCards.innerHTML = "";
                let xStart = (this.currentPage - 1) * this.perPage;
                let xEnd = xStart + this.perPage < this.filteredResults.length ? xStart + this.perPage : this.filteredResults.length;
                for(let v = xStart; v < xEnd; v++){
                    let divIcon = document.createElement("div");
                    divIcon.classList.add("tiles__card-icon");
                    let divContent = document.createElement("div");
                    divContent.classList.add("tiles__card-content");
                    let divDescription = new DOMParser().parseFromString(this.filteredResults[v].tile_desc, "text/xml");
                    let tileHeading = document.createElement("h2");
                    let classes = "text-2xl font-light mb-4".split(" ");
                    tileHeading.classList.add(...classes);
                    tileHeading.innerHTML = this.filteredResults[v].name;
                    divContent.appendChild(tileHeading);
                    divDescription.childNodes.forEach(function(v) {
                        divContent.appendChild(v.firstChild);
                    });
                    let divCard = document.createElement("div");
                    divCard.classList.add("tiles__card");
                    if (this.filteredResults[v].tile_img != "") {
                        divIcon.style.backgroundImage = "url('" + this.filteredResults[v].tile_img + "')";
                        divCard.appendChild(divIcon);
                    }
                    divCard.appendChild(divContent);
                    let link = document.createElement("a");
                    link.setAttribute("href", this.filteredResults[v].url);
                    link.appendChild(divCard);
                    let listItem = document.createElement("li");
                    listItem.appendChild(link);
                    this.resultCards.appendChild(listItem);
                }
                this.buildPagination();
                document.querySelector("#topical__cards").scrollIntoView({
                    behavior: "smooth"
                });
            }
            this.getParams();
            if (this.urlParams.page == undefined) this.newUrlState += this.newUrlState == "" ? "?page=" + this.currentPage : "&page=" + this.currentPage;
            else //this.buildTopicQueryString()
            //this.newUrlState = this.topicQueryString == "" ? "?page=" + this.currentPage : this.topicQueryString + "&page=" + this.currentPage;
            this.buildQueryString("page", this.currentPage);
            history.replaceState(null, "", this.newUrlState);
            (e)=>e.preventDefault();
            return false;
        },
        "changePerPage": function(e) {
            this.perPage = parseInt(e.target.value);
            this.currentPage = 1;
            this.resultCards.innerHTML = "";
            let xStart = (this.currentPage - 1) * this.perPage;
            let xEnd = xStart + this.perPage < this.filteredResults.length ? xStart + this.perPage : this.filteredResults.length;
            for(let v = xStart; v < xEnd; v++){
                let divIcon = document.createElement("div");
                divIcon.classList.add("tiles__card-icon");
                let divContent = document.createElement("div");
                divContent.classList.add("tiles__card-content");
                let divDescription = new DOMParser().parseFromString(this.filteredResults[v].tile_desc, "text/xml");
                let tileHeading = document.createElement("h2");
                let classes = "text-2xl font-light mb-4".split(" ");
                tileHeading.classList.add(...classes);
                tileHeading.innerHTML = this.filteredResults[v].name;
                divContent.appendChild(tileHeading);
                divDescription.childNodes.forEach(function(v) {
                    divContent.appendChild(v.firstChild);
                });
                let divCard = document.createElement("div");
                divCard.classList.add("tiles__card");
                if (this.filteredResults[v].tile_img != "") {
                    divIcon.style.backgroundImage = "url('" + this.filteredResults[v].tile_img + "')";
                    divCard.appendChild(divIcon);
                }
                divCard.appendChild(divContent);
                let link = document.createElement("a");
                link.setAttribute("href", this.filteredResults[v].url);
                link.appendChild(divCard);
                let listItem = document.createElement("li");
                listItem.appendChild(link);
                this.resultCards.appendChild(listItem);
            }
            this.buildPagination();
        },
        "buildFilter": function() {
            this.topicKeys = [];
            this.topics = [];
            var that = this;
            this.results.forEach(function(v, k) {
                v.topics.forEach(function(tpc, s) {
                    if (!that.topicKeys.includes(tpc)) {
                        that.topicKeys.push(tpc);
                        let t = {};
                        t.key = tpc;
                        t.value = v.topic_values[s];
                        if (t.key != "" && t.value != "" && t.value != undefined) that.topics.push(t);
                    }
                });
            });
            this.filterContainer = document.getElementById("topical__filter-fields");
            var ul = document.createElement("ul");
            var li;
            var chck;
            var lbl;
            var spn;
            let liAll = document.createElement("li");
            let chckAll = document.createElement("input");
            chckAll.type = "checkbox";
            chckAll.name = "topics";
            chckAll.value = "all";
            chckAll.id = "topic-all";
            chckAll.addEventListener("change", function(e) {
                that.currentPage = 1;
                that.buildResults(e);
            });
            let lblAll = document.createElement("label");
            lblAll.htmlFor = "topic-all";
            lblAll.appendChild(chckAll);
            let spnAll = document.createElement("span");
            spnAll.textContent = "Select all";
            lblAll.appendChild(spnAll);
            liAll.appendChild(lblAll); // append the text to the li
            ul.appendChild(liAll); // append the list item to the ul
            this.topics.forEach(function(item, k) {
                li = document.createElement("li");
                chck = document.createElement("input");
                chck.type = "checkbox";
                chck.name = "topics";
                chck.value = item.key;
                chck.id = "topic-" + item.key;
                if (that.urlParams.topic == undefined || that.urlParams == "") chck.checked = true;
                else if (item.key == that.urlParams.topic || Array.isArray(that.urlParams.topic) && that.urlParams.topic.includes(item.key)) chck.checked = true;
                else chck.checked = false;
                chck.classList.add("filter-topic");
                chck.addEventListener("change", function(e) {
                    that.currentPage = 1;
                    that.buildResults(e);
                });
                lbl = document.createElement("label");
                lbl.htmlFor = "topic-" + item.key;
                lbl.appendChild(chck);
                spn = document.createElement("span");
                spn.textContent = item.value;
                lbl.appendChild(spn);
                li.appendChild(lbl); // append the text to the li
                ul.appendChild(li); // append the list item to the ul
            });
            this.filterContainer.replaceChildren(ul);
        },
        "checkAllTopics": function(e) {
            var that = this;
            if (e.target.id == "topic-all") {
                // Remove all URL state
                that.newUrlState = that.basePath; // "/initiatives.html";
                if (e.target.checked) // Check all topics
                this.filterContainer.querySelectorAll("input.filter-topic").forEach(function(v) {
                    v.checked = true;
                });
            } else {
                that.newUrlState = "";
                var allTopics = true;
                var selectedTopic;
                this.filterContainer.querySelectorAll("input.filter-topic").forEach(function(v) {
                    if (v.checked == false) {
                        that.filterContainer.querySelector("#topic-all").checked = false;
                        allTopics = false;
                    } else that.newUrlState += that.newUrlState == "" ? "?topic=" + v.value : "&topic=" + v.value;
                });
                that.filterContainer.querySelector("#topic-all").checked = allTopics;
                if (allTopics) that.newUrlState = that.basePath; // "/initiatives.html";
            }
            that.keywords = document.querySelector("input[name='search-keywords']").value.trim();
            if (that.keywords != "") that.newUrlState += that.newUrlState == that.basePath ? "?search=" + encodeURIComponent(that.keywords) : "&search=" + encodeURIComponent(that.keywords);
            history.replaceState(null, "", that.newUrlState);
        },
        "buildResults": function(e) {
            if (e != undefined) this.checkAllTopics(e);
            /** This scan the filter and applied the result at once */ this.currentPage = this.currentPage == undefined ? 1 : this.currentPage;
            this.filterResults();
            this.buildPagination();
        },
        "filterResults": function() {
            this.filteredResults = [];
            this.selected = [];
            this.resultCards = document.getElementById("topical__cards-list");
            var that = this;
            var li = document.querySelectorAll("#topical__filter-fields ul li");
            this.keywords = document.querySelector("input[name='search-keywords']").value.trim().replace("  ", " ");
            let arKeywords = [];
            if (this.keywords != "") arKeywords = this.keywords.split(" ");
            li.forEach(function(v, k) {
                if (v.querySelector("input").checked) that.selected.push(v.querySelector("input").value);
            });
            this.resultCards.innerHTML = "";
            this.results.forEach(function(v, k) {
                v.topics.every(function(e, s) {
                    if (that.selected.includes(e) && that.matchKeywords(arKeywords, v)) {
                        that.filteredResults.push(v);
                        return false;
                    }
                    return true;
                });
            });
            let totalFilteredResults = this.filteredResults.length;
            let totalOfPagesFiltered = Math.ceil(totalFilteredResults / this.perPage);
            if (totalOfPagesFiltered < this.currentPage) {
                this.currentPage = 1;
                this.buildQueryString("page", 1);
                history.replaceState(null, "", this.newUrlState);
            }
            this.resultCards.innerHTML = "";
            let xStart = (this.currentPage - 1) * this.perPage;
            let xEnd = xStart + this.perPage < this.filteredResults.length ? xStart + this.perPage : this.filteredResults.length;
            for(let v = xStart; v < xEnd; v++){
                let divIcon = document.createElement("div");
                divIcon.classList.add("tiles__card-icon");
                let divContent = document.createElement("div");
                divContent.classList.add("tiles__card-content");
                let divDescription = new DOMParser().parseFromString(this.filteredResults[v].tile_desc, "text/xml");
                let tileHeading = document.createElement("h2");
                let classes = "text-2xl font-light mb-4".split(" ");
                tileHeading.classList.add(...classes);
                tileHeading.innerHTML = this.filteredResults[v].name;
                divContent.appendChild(tileHeading);
                divDescription.childNodes.forEach(function(v) {
                    divContent.appendChild(v.firstChild);
                });
                let divCard = document.createElement("div");
                divCard.classList.add("tiles__card");
                if (this.filteredResults[v].tile_img != "") {
                    divIcon.style.backgroundImage = "url('" + this.filteredResults[v].tile_img + "')";
                    divCard.appendChild(divIcon);
                }
                divCard.appendChild(divContent);
                let link = document.createElement("a");
                link.setAttribute("href", this.filteredResults[v].url);
                link.appendChild(divCard);
                let listItem = document.createElement("li");
                listItem.appendChild(link);
                this.resultCards.appendChild(listItem);
            }
        }
    };
    initiatives.init();
    /** For debugging only. Should be removed. */ window.initiatives = initiatives;
})();

//# sourceMappingURL=initiatives.cd593c73.js.map
